module.exports = __webpack_public_path__ + "SourceSansPro-SemiBoldItalic.367556ded49a1615b8a0.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/SourceSansPro-SemiBoldItalic.eot
// module id = ../../../../../src/assets/customfonts/SourceSansPro-SemiBoldItalic.eot
// module chunks = styles